import { useReduxState } from 'hooks';
import { AddChapter } from 'components/courses/common';

const EditorEmpty = () => {
  const { messages, theme } = useReduxState();

  return (
    <div className="empty">
      <div>{messages.editNoChapters}</div>
      <div className="create">
        <AddChapter />
      </div>

      <style jsx>{`
        .empty {
          color: ${theme.textColorLighter};
          font-size: 1.6rem;
          margin: 50px 0;
          text-align: center;
          width: 100%;
        }
        .create {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default EditorEmpty;
